import { TagFiltersState } from './types';

export const CLEAR_BUTTON_WIDTH = 75;
export const MAX_TAG_WIDTH = 160;
export const TAG_REST_WIDTH = 40;
export const DUMMY_COUNT = 1;
export const DROPDOWN_DESKTOP_BUTTON_WIDTH = 160;
export const DROPDOWN_MOBILE_BUTTON_WIDTH = 60;
export const GRID_GAP = 4;
export const RESIZE_DEBOUNCE_TIME = 400;
export const UPDATE_PERIOD = 500;
export const DESKTOP_PADDING = 150;
export const MOBILE_PADDING = 100;

export const DEFAULT_TAG_FILTERS_STATE: TagFiltersState = {
  searchQuery: '',
  selectedTags: [],
  isExpanded: false,
  shownTags: [],
  showAllTags: false,
  moreTagsCount: 0,
};
